export default __webpack_public_path__ + "static/media/opeansea.b5c406fc.svg";